import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({
  page,
  pageCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 30, 40, 50],
  className = '',
}) => {
  const totalPages = Math.max(1, pageCount);
  if (totalPages <= 1 && !onPageSizeChange) return null;

  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 ${className}`}>
      {onPageSizeChange ? (
        <label className="flex items-center gap-2 text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
          <span>Rows</span>
          <select
            className="form-select form-select-sm w-auto"
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
          >
            {pageSizeOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>
      ) : (
        <span />
      )}

      <div className="flex items-center gap-2">
        <span className="text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
          Page {page + 1} of {totalPages}
        </span>
        <button
          type="button"
          aria-label="Previous page"
          disabled={page <= 0}
          onClick={() => onPageChange(page - 1)}
          className="btn btn-icon btn-light-secondary disabled:opacity-50 disabled:pointer-events-none"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <button
          type="button"
          aria-label="Next page"
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(page + 1)}
          className="btn btn-icon btn-light-secondary disabled:opacity-50 disabled:pointer-events-none"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
